<template>
  <div class="ai-loading w-100 h-100" v-if="resultsEn">
    <div class="d-md-flex mb-3 btns">
      <!-- <a class="btn btn-clear mx-2 d-inline-block d-flex align-items-center justify-content-center mb-2 mb-md-0"
        @click="reGenerate"><img src="@/assets/image/ai/re_icon.png" alt="" class="object-contain mr-1">重新生成
      </a> -->
      <!-- <a class="btn btn-clear mx-2 d-inline-block d-flex align-items-center justify-content-center mb-2 mb-md-0"
        @click="copyAll(resultsEn)"><img src="@/assets/image/ai/copy.png" alt="" class="object-contain mr-1">全文複製
      </a> -->
      <a class="btn mx-2 d-inline-block d-flex align-items-center justify-content-center" v-if="$route.name !== 'ai_assistant_correction' && $route.params.generateType !== 'correct'"
        @click="toggleSwitch()" :class="{ 'btn-player-disabled': !ttsUrlFemale || !ttsUrlMale, 'btn-clear': ttsUrlFemale && ttsUrlMale, 'btn-clear--active': ttsUrlFemale && ttsUrlMale && isShowPlayer }">
        <img src="@/assets/image/ai/player_icon.png" alt="" class="object-contain mr-1">全文播放
      </a>
      <!-- <a class="btn mx-2 d-inline-block d-flex align-items-center justify-content-center btn-clear"
        @click="downloadTextFile()">
        <img src="@/assets/image/ai/btn_text_download.png" alt="" class="object-contain mr-1">.txt 文檔下載
      </a> -->
    </div>
    <div class="d-sm-flex align-items-center justify-content-between mb-3" v-if="ttsUrlMale && ttsUrlFemale && isShowPlayer">
      <div class="toggle-switch mr-sm-2 pointer position-relative d-flex align-items-center justify-content-center" @click="toggleGender()">
        <p class="text-center text-white font-semibold">{{ gender }}</p>
        <div class="position-absolute toggle-switch-button" :class="{ 'toggle-switch-button_female': gender === 'female', 'toggle-switch-button_male': gender === 'male' }">
          <img src="@/assets/image/ai/icon_voice_female_on.png" alt="" class="object-contain female">
          <img src="@/assets/image/ai/icon_voice_male_on.png" alt="" class="object-contain male">
        </div>
      </div>
      <VideoPlayer class="flex-1 ml-2" :ttsUrl="ttsUrlSwitch" />
    </div>
    <div class="w-100 h-100 results">
      <WordDictM class="d-lg-none" v-if="dictIdx !== -1" v-on:closeDict="closeDict" :content="ductWord" />

      <div class="d-flex bg-white py-3 py-md-4 px-2 px-md-3" v-if="resultsEn" :class="{ 'flex-column': $route.name === 'ai_assistant_follow' }">
        <div class="flex-1 px-2" :class="{ 'order-3': $route.name === 'ai_assistant_follow' }">

          <div v-if="$route.name === 'ai_assistant_correction' || ($route.name === 'viewGenerate' && $route.params.generateType === 'correct')">
            <div :style="`font-size: ${fontSize}px`" >
              <p class="m-0 p-0" v-if="returnCorrection && returnCorrection.contentCheck" v-html="returnCorrection.contentCheck.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
            </div>
          </div>
          <div v-else>
            <div class="results_en" :style="`font-size: ${fontSize}px`" id="target" v-if="$route.name !== 'ai_assistant_follow'">
              <p class="m-0 p-0"><span class="m-0 p-0" v-for="(item, index) in sentenceSpliter" :key="index" :class="{ 'active': dictIdx === index, 'pointer isDictionary': isDictionary && !isRegular(item) }" @click.stop="setIdxEn(item, index)">{{ item }}<WordDict class="d-none d-lg-block" v-if="dictIdx === index" v-on:closeDict="closeDict" :content="ductWord"/></span></p>
            </div>
            <div :style="`font-size: ${fontSize}px`" v-if="$route.name === 'ai_assistant_follow'">
              <sentence_practice v-for="(item, index) in textValSplit" :key="index" :textItem="textValSplit[index]" :isDictionary="isDictionary" :gender="gender" />
            </div>
            <div id="resultsZh" ref="resultsZh" class="results_zh pl-2 mt-4" v-if="isShowZn && resultsZh" :style="`font-size: ${fontSize}px`">
              <p v-html="resultsZh.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
            </div>
          </div>
        </div>
        <div class="d-flex pr-2 pl-2 pl-md-3" :class="{ 'flex-column': $route.name !== 'ai_assistant_follow', 'order-1 flex-row': $route.name === 'ai_assistant_follow' }">
          <a class="block mb-3 hover-item pointer tooltip-outer" @click="fontSize = 14" :class="{ 'active': fontSize === 14, 'mr-3': $route.name === 'ai_assistant_follow' }">
            <img src="@/assets/image/ai/btn_A1.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A1_active.png" alt="" class="on">
            <span class="tooltiptext">字型變小</span>
          </a>
          <a class="block mb-3 hover-item pointer tooltip-outer" @click="fontSize = 16" :class="{ 'active': fontSize === 16, 'mr-3': $route.name === 'ai_assistant_follow' }">
            <img src="@/assets/image/ai/btn_A2.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A2_active.png" alt="" class="on">
            <span class="tooltiptext">字型一般</span>
          </a>
          <a class="block mb-3 hover-item pointer tooltip-outer" @click="fontSize = 18" :class="{ 'active': fontSize === 18, 'mr-3': $route.name === 'ai_assistant_follow' }">
            <img src="@/assets/image/ai/btn_A3.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A3_active.png" alt="" class="on">
            <span class="tooltiptext">字型放大</span>
          </a>
          <a class="block mb-3 hover-item pointer tooltip-outer" @click="toggleZn" :class="{ 'active': isShowZn, 'mr-3': $route.name === 'ai_assistant_follow' }" v-if="$route.name !== 'ai_assistant_correction' && $route.params.generateType !== 'correct'">
            <img src="@/assets/image/ai/btn_A4.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A4_active.png" alt="" class="on">
            <span class="tooltiptext">中文翻譯</span>
          </a>
          <a class="block mb-3 hover-item pointer tooltip-outer" @click="isDictionary = !isDictionary" :class="{ 'active': isDictionary, 'mr-3': $route.name === 'ai_assistant_follow' }" v-if="$route.name !== 'ai_assistant_correction' && $route.params.generateType !== 'correct'">
            <img src="@/assets/image/ai/btn_A5.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A5_active.png" alt="" class="on">
            <span class="tooltiptext">字典模式</span>
          </a>
          <a class="block pointer tooltip-outer" @click="downloadTextFile" >
            <img src="@/assets/image/ai/btn_D.png" alt="">
            <span class="tooltiptext">下載</span>
          </a>
        </div>
      </div>
      <div class="d-flex mt-4" v-if="$route.name === 'ai_assistant_correction' || ($route.name === 'viewGenerate' && $route.params.generateType === 'correct')">
        <a class="p-2 border rounded-top mr-2 text-blue-main border-blue-main-toeic2 pointer" :class="{ 'bg-blue-main text-white': selectedItem === 0 }" @click="selectedItem = 0">文法與字彙修正</a>
        <a class="p-2 border rounded-top mr-2 text-blue-main border-blue-main-toeic2 pointer" :class="{ 'bg-blue-main text-white': selectedItem === 1 }" @click="selectedItem = 1">整體回饋</a>
        <a class="p-2 border rounded-top text-blue-main border-blue-main-toeic2 pointer" :class="{ 'bg-blue-main text-white': selectedItem === 2 }" @click="selectedItem = 2">AI範文</a>
      </div>
      <div class="bg-white mt-4 py-3 py-md-4 px-2 px-md-3" v-if="resultsEn && correction && $route.name !== 'ai_assistant_correction' && $route.name !== 'viewGenerate'" v-html="correction.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></div>
      <div class="bg-white py-3 py-md-4 px-2 px-md-3" v-if="resultsEn && correction && returnCorrection && ($route.name === 'ai_assistant_correction' || ($route.name === 'viewGenerate' && $route.params.generateType === 'correct'))">
        <div class="d-flex justify-content-end w-100" v-if="selectedItem === 2 && aiType === 'speech'">
          <a class="btn mx-2 d-inline-block btn-clear mb-1" @click="toFollowPage()">
            <img src="@/assets/image/ai/btn_follow.png" alt="" class="object-contain mr-1">跟讀練習
          </a>
        </div>
        <div v-if="selectedItem === 0">
          <p v-if="returnCorrection.sentences && returnCorrection.sentences.length > 0">以下提供{{ returnCorrection.sentences.length }}項文法與字彙修正建議，希望能幫助你文法與用字更精準，以提升整體英文能力：</p>
          <ul v-if="returnCorrection.sentences && returnCorrection.sentences.length > 0" class="list-decimal">
            <li v-for="(item, index) in returnCorrection.sentences" :key="index" class="mb-2">
              <p class="p-0 m-0"><span class="font-bold">原句：</span>{{ item.sentence }}</p>
              <p class="p-0 m-0"><span class="font-bold">建議：</span>{{ item.advice }}</p>
              <p class="p-0 m-0"><span class="font-bold">說明：</span>{{ item.rewriteSentence }}</p>
            </li>
          </ul>
        </div>
        <div v-if="selectedItem === 1 && typeof returnCorrection.summarize === 'object'">
          <p v-if="returnCorrection.summarize.salutation">
            &#9679;開頭稱謂：<span v-html="returnCorrection.summarize.salutation.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span>
          </p>
          <p v-if="returnCorrection.summarize.body">
            &#9679;信件本文：<span v-html="returnCorrection.summarize.body.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span>
          </p>
          <p class="mb-3" v-if="returnCorrection.summarize.closing">
            &#9679;結尾敬語與署名：<span v-html="returnCorrection.summarize.closing.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span>
          </p>
          <p v-if="returnCorrection.summarize.content" >
            &#9679;整體回饋：<span v-html="returnCorrection.summarize.content.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span>
          </p>
        </div>
        <div v-if="selectedItem === 1 && typeof returnCorrection.summarize === 'string'">
          <p v-if="returnCorrection?.summarize" >
            <span v-html="returnCorrection.summarize.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span>
          </p>
        </div>
        <p v-if="selectedItem === 2 && returnCorrection?.rewriteArticle?.english" v-html="returnCorrection.rewriteArticle.english.replace(/(?:\r\n|\r|\n)/g, '<br/>')" class="mb-3"></p>
        <p v-if="selectedItem === 2 && returnCorrection?.rewriteArticle?.chinese" v-html="returnCorrection.rewriteArticle.chinese.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable no-multiple-empty-lines -->
<script>
  import api from '@/store/api'
  import WordDict from '@/components/AiHelper/WordDict'
  import WordDictM from '@/components/AiHelper/WordDictM'
  // import AudioPlayer from '@/components/AiHelper/speech/AudioPlayer'
  import VideoPlayer from '@/components/AiHelper/speech/VideoPlayer'
  import dictApi from '@/store/library/api'
  import * as OpenCC from 'opencc-js'
  import sentence_practice from '@/components/AiHelper/speech/sentence_practice.vue'
  export default {
    name: 'GenerateResults',
    data () {
      return {
        timer: null,
        fontSize: 16,
        isShowZn: false,
        isShowPlayer: false,
        isDictionary: true,

        ductWord: null,
        dictIdx: -1,

        gender: 'female',

        selectedItem: 0
      }
    },
    props: {
      resultsEn: {
        type: String,
        default: null
      },
      resultsZh: {
        type: String,
        default: null
      },
      aiType: {
        type: String,
        default: 'letter'
      },
      ttsUrlMale: {
        type: String,
        default: null
      },
      ttsUrlFemale: {
        type: String,
        default: null
      },
      correction: {
        type: String,
        default: null
      },
      textValSplit: {
        type: Array,
        default: []
      },
      textVal: {
        type: String,
        default: null
      }
    },
    components: {
      WordDict,
      WordDictM,
      VideoPlayer,
      sentence_practice
    },
    mounted () {
      if (this.returnCorrection?.rewriteArticle?.english) {
        this.$store.dispatch("saveFollowData", this.returnCorrection.rewriteArticle.english)
      }
    },
    computed: {
      ttsUrlSwitch () {
        let self = this
        if (self.gender === 'female') {
          return self.ttsUrlFemale
        } else {
          return self.ttsUrlMale
        }
      },
      sentenceSpliter () {
        let str
        const pattern = /\p{L}[\p{L}\p{N}]*(?:['’\-][\p{L}\p{N}]+)*|\p{N}+|[^\p{L}\p{N}'’\-\s]|\s+/gu
        if (this.returnCorrection && this.returnCorrection.contentCheck) {
          str = this.returnCorrection.contentCheck
        } else {
          str = this.resultsEn
        }
        return str.match(pattern) || []
      },
      returnCorrection () {
        if (this.$route.name === 'ai_assistant_correction' || this.$route.params.generateType === 'correct') {
          return JSON.parse(this.correction)
        }
        return null
      }
    },
    watch: {
    },
    destroyed () {
    },
    methods: {
      toggleGender() {
        this.gender = this.gender === 'female' ? 'male' : 'female'
      },

      async toggleZn () {
        let self = this
        const converter = OpenCC.Converter({ from: 'cn', to: 'tw' })

        if (self.resultsZh) {
          self.isShowZn = !self.isShowZn
        } else {
          let path = `/ai/generate/translate`

          await api.post(path, {
            content: self.resultsEn
          })
          .then((res) => {
            if (res.data && res.data.result) {
              self.$emit('resultsZh', converter(res.data.result))
              self.isShowZn = !self.isShowZn
              self.$emit('getZnPopUp')
            } else {
              self.$emit('failPopUp')
            }
          })
          .catch(() => {
            self.$emit('failPopUp')
          })
        }
      },

      selectText (nodeId) {
        const node = document.getElementById(nodeId)

        if (document.body.createTextRange) {
          const range = document.body.createTextRange()
          range.moveToElementText(node)
          range.select()
        } else if (window.getSelection) {
          const selection = window.getSelection()
          const range = document.createRange()
          range.selectNodeContents(node)
          selection.removeAllRanges()
          selection.addRange(range)
        } else {
          console.warn('Could not select text in node: Unsupported browser.')
        }
      },

      async copyAll (text) {
        let self = this
        self.selectText('target')

        navigator.clipboard
          .writeText(text)
          .then(() => {
            alert('successfully copied')
          })
          .catch(() => {
            alert('something went wrong')
          })
      },

      closeDict () {
        let self = this
        self.ductWord = null
        self.dictIdx = -1
      },

      async setIdxEn (item, idx) {
        let self = this
        if (self.isDictionary && !self.isRegular(item)) {
          const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${item}`)
          self.dictIdx = idx
          self.ductWord = data.data
        }
      },

      isRegular (val) {
        // eslint-disable-next-line no-useless-escape
        let pattern = new RegExp(/[^\p{L}\p{N}'’\-]/u)
        if (val && val.match(pattern)) {
          return true
        }
        return false
      },

      toggleSwitch () {
        let self = this
        if (self.ttsUrlFemale && self.ttsUrlMale) {
          self.isShowPlayer = !self.isShowPlayer
        }
      },

      downloadTextFile () {
        if ((this.$route.name !== 'ai_assistant_correction' && !this.resultsEn) ||
            (this.$route.name === 'ai_assistant_correction' && !this.returnCorrection)) {
          return
        }
        // 建立 Blob 物件
        let text
        if (this.$route.name !== 'ai_assistant_correction' && this.$route.params.generateType !== 'correct') {
          text = this.resultsEn
        } else {
          let result = ''
          if (this.returnCorrection.sentences.length > 0) {
            for (let i = 0; i < this.returnCorrection.sentences.length; i++) {
              result += `${i + 1}原句: ${this.returnCorrection.sentences[i].sentence}\n`
              result += `建議: ${this.returnCorrection.sentences[i].advice}\n`
              result += `說明: ${this.returnCorrection.sentences[i].rewriteSentence}\n`
            }
          }

          let summarizeData
          if (this.aiType === 'speech') {
            summarizeData = `\n${this.returnCorrection.summarize}`
          } else {
            summarizeData = `\n●開頭稱謂：${this.returnCorrection.summarize.salutation}\n●信件本文：${this.returnCorrection.summarize.body}\n●結尾敬語與署名：${this.returnCorrection.summarize.closing}\n\n●整體回饋：${this.returnCorrection.summarize.content}`
          }
          const values = [
            `${this.textVal}\n`,
            `文法與字彙修正 以下提供${this.returnCorrection.sentences.length}項文法與字彙修正建議，希望能幫助你文法與用字更精準，以提升整體英文能力：\n` + result + '\n',
            `整體回饋 ${summarizeData || ''}\n`,
            `AI範文 \n${this.returnCorrection.rewriteArticle.english || ''}\n\n${this.returnCorrection.rewriteArticle.chinese || ''}`
          ];
          text = values.join("\n")
        }
        const blob = new Blob([text], { type: "text/plain;charset=utf-8" })

        // 建立臨時連結
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = 'download.txt'

        // 觸發下載
        document.body.appendChild(link)
        link.click();

        // 清理
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      },

      toFollowPage () {
        if (!this.returnCorrection.rewriteArticle.english) return
          const myName1 = () => {
            return new Promise(async(resolve) => {
              this.$store.dispatch("saveFollowData", this.returnCorrection.rewriteArticle.english)
              if (localStorage.getItem("followData")) {
                resolve('1')
              }
            })
          }

          Promise.race([myName1()])
          .then(() => {
            this.$nextTick(() => {
              this.$router.push({ name: 'ai_assistant_follow', query: { follow: 'true' } })
            })
          })
      }
    }
  }
</script>
<style lang="scss" scoped>
  a {
    &:hover {
      text-decoration: none !important;
    }
  }
  .btn-player-disabled {
    border-radius: 8px;
    border: 1px solid #F30000;
    background: #FFF;
    color: #F30000;
    text-align: center;
    font-family: Noto Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    min-width: 160px;
    cursor: default;
    opacity: 0.3;
  }
  .results {
    line-height: 1.8;
    .results_en {
      p {
        white-space: pre-line;
        word-break: normal;
        margin-bottom: 0;
        span {
          position: relative;
        }
        .isDictionary {
          &:hover {
            background-color: #BBDDFF;
          }
        }
        .active {
          background-color: #BBDDFF;
        }
      }
    }
    .results_zh {
      border-left: 4px solid #2A86E0;
      color: #135BA3;
    }
  }
  .block {
    display: block;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .active {
    .off {
        display: none;
      }
    .on {
      display: block;
    }
  }
  .toggle-switch {
    width: 170px;
    height: 48px;
    background-color: #0E103E;
    border-radius: 35px;
    background-image: url('~@/assets/image/ai/icon_voice_female_off.png'), url('~@/assets/image/ai/icon_voice_male_off.png');
    background-repeat: no-repeat;
    background-position: top 4px left 4px, top 4px right 4px;
    transition: .3s;
    .toggle-switch-button {
      top: 4px;
      z-index: 99;
    }
    .toggle-switch-button_female {
      left: 4px;
      .male {
        opacity: 0;
      }
    }
    .toggle-switch-button_male {
      right: 4px;
      .female {
        opacity: 0;
      }
    }
  }
</style>
